import { Polygons } from './polygons';
export default Polygons;
